const HTML_TAG_PATTERN = /<[a-z][\s\S]*>/i;
const LINE_BREAK_TAG_PATTERN = /<br\s*\/?>/gi;
const BLOCK_END_TAG_PATTERN = /<\/(?:p|div|li|h[1-6])>/gi;

export const htmlToText = (html: string | null | undefined): string => {
    if (!html || !HTML_TAG_PATTERN.test(html)) {
        return html ?? '';
    }

    const parser = new DOMParser();
    const parsed = parser.parseFromString(
        html.replace(LINE_BREAK_TAG_PATTERN, '\n').replace(BLOCK_END_TAG_PATTERN, '$&\n'),
        'text/html'
    );

    parsed.body.querySelectorAll('script,style,noscript,template').forEach((element) => element.remove());

    return (
        parsed.body.textContent
            ?.replace(/\u00A0/g, ' ')
            .replace(/[ \t]+\n/g, '\n')
            .replace(/\n{3,}/g, '\n\n')
            .trim() ?? ''
    );
};
